var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var PublicInfo = /** @class */ (function (_super) {
    __extends(PublicInfo, _super);
    function PublicInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.address = null;
        _this.postalCode = null;
        _this.city = null;
        _this.country = null;
        _this.phoneNumber = null;
        _this.email = null;
        _this.dpoName = null;
        _this.dpoPhoneNumber = null;
        _this.dpoEmail = null;
        return _this;
    }
    Object.defineProperty(PublicInfo.prototype, "fullAddress", {
        get: function () {
            return [this.address, this.postalCode, this.city, this.country]
                .filter(Boolean)
                .join(' ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PublicInfo.prototype, "hasContactInfo", {
        get: function () {
            return !!this.fullAddress || !!this.phoneNumber || !!this.email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PublicInfo.prototype, "hasDpo", {
        get: function () {
            return !!this.dpoName || !!this.dpoPhoneNumber || !!this.dpoEmail;
        },
        enumerable: false,
        configurable: true
    });
    return PublicInfo;
}(Entity));
export { PublicInfo };
